import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/privateOffersTable';
import filters from '@/components/builders/configs/filters/privateOffersFilters';
import editorDialog from './submodules/editorDialog';
import getters from './getters';
import actions from './action';
import mutations from './mutation';

const privateOffersRepository = RepositoryFactory.get('privateOffers');
const state = {
  repository: privateOffersRepository,
  error: null,
};

export default stateExtender({
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: privateOffersRepository.table,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
    editorDialog,
  },
  getters,
  mutations,
  actions,
});
